import { render, staticRenderFns } from "./SettingsFontsPage.vue?vue&type=template&id=4594f149&"
import script from "./SettingsFontsPage.vue?vue&type=script&lang=ts&"
export * from "./SettingsFontsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports